import { usingGet, usingPost, createProxyUrl } from '@ocean/api'
import { UserUtils } from 'utils'
import routes from 'modules/Auth/routing/routes'
import {
  AuthUserParams,
  ForgotPasswordParams,
  SetupPasswordParams,
  SetupPasswordEmailLinkParams,
  ChangePasswordParams,
  RegisterParams,
} from 'modules/Auth/types'

export const login = (formData: AuthUserParams) =>
  usingPost('Session/Authentication', formData, { useProxy: true })

export const forgotPassword = (formData: ForgotPasswordParams) =>
  usingPost(
    'System/ResetMyPassword',
    {
      ...formData,
      resetPasswordRoute: routes.setup,
    },
    { useProxy: true }
  )

export const setupPassword = (
  formData: SetupPasswordParams,
  emailLinkParams: SetupPasswordEmailLinkParams
) => {
  const { password } = formData
  return usingPost(`System/RestoreForgottenPassword`, {
    newPassword: password,
    ...emailLinkParams,
  })
}

export const changePassword = (formData: ChangePasswordParams, authUserParams: AuthUserParams) => {
  const { password: newPassword } = formData
  const { customer, userId: accountId, password: currentPassword } = authUserParams
  return usingPost(`System/ChangeAccountPassword`, {
    newPassword,
    customer,
    accountId,
    currentPassword,
  })
}

export const getAccount = () => {
  const { userId } = UserUtils.getUserLoginParams()
  return usingGet(`Accounts/GetAccount?id=${userId}`)
}

export const getLogonLogoSource = (customer: string, timestamp?: Nullable<string>): string => {
  return createProxyUrl(`system/customerLogo?customer=${customer}&timestamp=${timestamp}`)
}

export const registerInstallation = (formData: RegisterParams) => {
  return usingPost('System/Register', formData)
}

export const getSsoProviderIconSource = (
  customer: string,
  timestamp?: Nullable<string>
): string => {
  return createProxyUrl(
    `system/customerSsoProviderImage?customer=${customer}&timestamp=${timestamp}`
  )
}
